import { composite, changeColor, rgba, scaleColor } from 'seemly'

function neutral(base, invert, alpha) {
  const overlayRgba = Array.from(invert)
  overlayRgba[3] = Number(alpha)
  return composite(base, overlayRgba)
}

function overlay(rgb, alpha) {
  const overlayPrefix = `rgba(${rgb.slice(0, 3).join(', ')}, `
  return `${overlayPrefix + String(alpha)})`
}

function createHoverColor(color, overlayAlpha = 0.15) {
  return composite(color, [255, 255, 255, overlayAlpha])
}

function createPressedColor(color, overlayAlpha = 0.15) {
  return composite(color, [0, 0, 0, overlayAlpha])
}

export const commonOverrides = (vars) => {
  const baseColor = vars.BASE_COLOR
  const baseInvertColor = vars.BASE_INVERT_COLOR
  const primaryColor = vars.PRIMARY_COLOR
  const infoColor = vars.INFO_COLOR
  const successColor = vars.SUCCESS_COLOR
  const warningColor = vars.WARNING_COLOR
  const errorColor = vars.ERROR_COLOR
  const textColor = vars.TEXT_COLOR
  const alpha1 = vars.ALPHA_1
  const alpha2 = vars.ALPHA_2
  const alpha3 = vars.ALPHA_3
  const alpha4 = vars.ALPHA_4
  const alpha5 = vars.ALPHA_5
  const alphaClose = vars.ALPHA_CLOSE
  const alphaDisabled = vars.ALPHA_DISABLED
  const rgbaBase = rgba(baseColor)
  const rgbaBaseInvert = rgba(baseInvertColor)
  const clearColor = neutral(rgbaBase, rgbaBaseInvert, Number(alpha4))

  //   const alphaDisabledInput = vars.ALPHA_DISABLED_INPUT
  //   const alphaPending = vars.ALPHA_PENDING
  //   const alphaTablePending = vars.ALPHA_TABLE_PENDING
  //   const alphaPressed = vars.ALPHA_PRESSED

  const alphaAvatar = vars.ALPHA_AVATAR
  const alphaRail = vars.ALPHA_RAIL
  const alphaProgressRail = vars.ALPHA_PROGRESS_RAIL
  const alphaBorder = vars.ALPHA_BORDER
  const alphaDivider = vars.ALPHA_DIVIDER
  const alphaInput = vars.ALPHA_INPUT
  const alphaAction = vars.ALPHA_ACTION
  const alphaTab = vars.ALPHA_TAB
  const alphaScrollbar = vars.ALPHA_SCROLLBAR
  const alphaScrollbarHover = vars.ALPHA_SCROLLBAR_HOVER
  const alphaCode = vars.ALPHA_CODE
  const alphaTag = vars.ALPHA_TAG
  const alphaTable = vars.ALPHA_TABLE

  return {
    baseColor,
    popoverColor: baseColor,
    tableColor: baseColor,
    cardColor: baseColor,
    modalColor: baseColor,
    bodyColor: baseColor,
    hoverColor: changeColor(primaryColor, { alpha: 0.1 }),
    clearColor,
    primaryColor,
    primaryColorHover: createHoverColor(primaryColor),
    primaryColorPressed: createPressedColor(primaryColor),
    primaryColorSuppl: createHoverColor(primaryColor),
    infoColor,
    infoColorHover: createHoverColor(infoColor),
    infoColorPressed: createPressedColor(infoColor),
    infoColorSuppl: createHoverColor(infoColor),
    successColor,
    successColorHover: createHoverColor(successColor),
    successColorPressed: createPressedColor(successColor),
    successColorSuppl: createHoverColor(successColor),
    warningColor,
    warningColorHover: createHoverColor(warningColor),
    warningColorPressed: createPressedColor(warningColor),
    warningColorSuppl: createHoverColor(warningColor),
    errorColor,
    errorColorHover: createHoverColor(errorColor),
    errorColorPressed: createPressedColor(errorColor),
    errorColorSuppl: createHoverColor(errorColor),
    textColorBase: textColor,
    textColor1: changeColor(primaryColor, { alpha: 1 }),
    textColor2: changeColor(primaryColor, { alpha: 1 }),
    textColor3: 'red',
    textColor4: neutral(rgbaBase, rgbaBaseInvert, alpha4),
    textColor5: neutral(rgbaBase, rgbaBaseInvert, alpha5),
    textColorDisabled: neutral(rgbaBase, rgbaBaseInvert, alphaDisabled),
    placeholderColor: neutral(rgbaBase, rgbaBaseInvert, alpha4),
    placeholderColorDisabled: neutral(rgbaBase, rgbaBaseInvert, alpha5),
    iconColor: neutral(rgbaBase, rgbaBaseInvert, alpha4),
    iconColorHover: scaleColor(neutral(rgbaBase, rgbaBaseInvert, alpha4), { lightness: 0.75 }),
    iconColorPressed: scaleColor(neutral(rgbaBase, rgbaBaseInvert, alpha4), { lightness: 0.9 }),
    iconColorDisabled: neutral(rgbaBase, rgbaBaseInvert, alpha5),
    opacity1: alpha1,
    opacity2: alpha2,
    opacity3: alpha3,
    opacity4: alpha4,
    opacity5: alpha5,
    dividerColor: neutral(rgbaBase, rgbaBaseInvert, Number(alphaDivider)),
    borderColor: neutral(rgbaBase, rgbaBaseInvert, Number(alphaBorder)),
    // close
    closeIconColor: neutral(rgbaBase, rgbaBaseInvert, Number(alphaClose)),
    closeIconColorHover: neutral(rgbaBase, rgbaBaseInvert, Number(alphaClose)),
    closeIconColorPressed: neutral(rgbaBase, rgbaBaseInvert, Number(alphaClose)),
    closeColorHover: 'rgba(0, 0, 0, .09)',
    closeColorPressed: 'rgba(0, 0, 0, .13)',
    clearColorHover: scaleColor(clearColor, { lightness: 0.75 }),
    clearColorPressed: scaleColor(clearColor, { lightness: 0.9 }),

    scrollbarColor: overlay(rgbaBaseInvert, alphaScrollbar),
    scrollbarColorHover: overlay(rgbaBaseInvert, alphaScrollbarHover),
    scrollbarWidth: '5px',
    scrollbarHeight: '5px',
    scrollbarBorderRadius: '5px',

    progressRailColor: neutral(rgbaBase, rgbaBaseInvert, Number(alphaProgressRail)),
    railColor: neutral(rgbaBase, rgbaBaseInvert, Number(alphaRail)),
    tagColor: neutral(rgbaBase, rgbaBaseInvert, Number(alphaTag)),
    avatarColor: neutral(rgbaBase, rgbaBaseInvert, Number(alphaAvatar)),
    invertedColor: baseInvertColor,

    inputColor: neutral(rgbaBase, rgbaBaseInvert, Number(alphaInput)),
    codeColor: neutral(rgbaBase, rgbaBaseInvert, Number(alphaCode)),
    tabColor: neutral(rgbaBase, rgbaBaseInvert, Number(alphaTab)),
    actionColor: neutral(rgbaBase, rgbaBaseInvert, Number(alphaAction)),
    tableHeaderColor: neutral(rgbaBase, rgbaBaseInvert, Number(alphaTable)),
  }
}
